<ng-container *ngIf="matterLoading; else matterView">
	<atomic-loading-icon [testHook]="testHooks.LoadingIcon"></atomic-loading-icon>
	<div class="loading w-full top-[7.5rem]">
		{{ loadingMessage }}
	</div>
</ng-container>
<ng-template #matterView>
	<div [class.matter-page]="showNavigation" [class.min-h-0]="!showNavigation">
		<ng-container *ngIf="showNavigation">
			<div class="tabs">
				<app-last-opened-tabs
					*ngIf="showRecentlyOpened$ | async"
				></app-last-opened-tabs>
			</div>
			<app-top-sale-nav-bar
				class="top-nav"
				id="matter-top-nav"
			></app-top-sale-nav-bar>
			<app-side-nav class="side-nav"></app-side-nav>
		</ng-container>
		<div [class.body]="showNavigation" [class.h-full]="!showNavigation">
			<div
				*ngIf="showMessage$ | async as showMessage"
				class="flex bg-orange-lighter items-center gap-2 border-b border-grey-lighter p-2 text-sm"
				[@openClose]
			>
				<app-icon
					[icon]="WARNING_ICON"
					class="text-base"
					[testHook]="testHooks.WarningIcon"
				></app-icon>
				<p class="text-base">
					Changes have been made that impact your {{ showMessage }} order.
				</p>
				<p
					(click)="resubmitTitleInsurance()"
					class="font-bold cursor-pointer underline"
				>
					Review and resubmit
				</p>
			</div>
			<router-outlet class="hidden-router !hidden"></router-outlet>
		</div>
	</div>
</ng-template>
